/**
 * Returns a list with stopwords for the Slovak passive voice assessment.
 *
 * @returns {Array}                 The list with stopwords.
 */
export default [
	"ktorí",
	"ktorých",
	"ktorými",
	"ktorá",
	"ktorého",
	"ktorému",
	"ktorom",
	"ktorým",
	"ktorý",
	"ktoré",
	"ktorej",
	"ktorou",
	"ktorú",
	"lebo",
	"keby",
	"že",
	"aby",
	"alebo",
	"keďže",
	"kedže",
	"lenže",
	"ale",
	"nakoľko",
	"pretože",
	"či",
	"ak",
	"kedy",
];
